import { GPX_FEATURES, GPXFeature } from '@rsos/gainsight';
import useIsVT911Enabled from '../../../../../hooks/useIsVT911Enabled';
import { trackStartTF911Click } from '../../textFrom911Trackings';
import TF911StartChatNoAccordion from './TF911StartChatNoAccordion';

interface TF911StartChatAccordionProps {
  isCreatingConversation: boolean;
  isForOverview?: boolean;
  onStartConversation: (message?: string) => Promise<{ isSuccess: boolean }>;
  gpxFeature?: GPXFeature;
}

const TF911StartChatAccordion = ({
  isCreatingConversation,
  isForOverview = false,
  onStartConversation,
  gpxFeature = GPX_FEATURES.TF911,
}: TF911StartChatAccordionProps) => {
  const isVT911Enabled = useIsVT911Enabled();

  const handleDefaultStartClick = () => {
    onStartConversation();
    trackStartTF911Click({
      feature: gpxFeature,
      fromOverviewTab: isForOverview,
    });
  };

  return (
    <TF911StartChatNoAccordion
      handleDefaultStartClick={handleDefaultStartClick}
      isCreatingConversation={isCreatingConversation}
      isForOverview={isForOverview}
      isVT911Enabled={isVT911Enabled}
      onStartConversation={onStartConversation}
    />
  );
};

export default TF911StartChatAccordion;
